<template>
  <div class="archiveList">
    <ArchiveListItem
      v-for="a in archives"
      :key="a.id"
      :archive-item="a"
    />
  </div>
</template>

<script>

import ArchiveListItem from './ArchiveListItem'

export default {
  name: 'ArchivesList',
  components: {
    ArchiveListItem,
  },
  props: {
    archives: {
      type: Array,
      required: true,
    },
  },
}

</script>
